import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SavedAddressesModalEN from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/SavedAddressesModal/locales/SavedAddressesModal_en_US';
import SavedAddressesModalFR from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/SavedAddressesModal/locales/SavedAddressesModal_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SavedAddressesModalEN, SavedAddressesModalFR);

export const savedAddressesModalSelector = createStructuredSelector({
    title: getTextFromResource(getText, 'title'),
    cancelButtonText: getTextFromResource(getText, 'cancel'),
    confirmButtonText: getTextFromResource(getText, 'confirm'),
    noAddresses: getTextFromResource(getText, 'noAddresses'),
    showMore: getTextFromResource(getText, 'showMore'),
    showLess: getTextFromResource(getText, 'showLess'),
    defaultLabel: getTextFromResource(getText, 'defaultLabel'),
    editLabel: getTextFromResource(getText, 'editLabel'),
    removeLabel: getTextFromResource(getText, 'removeLabel'),
    editAddressLabel: getTextFromResource(getText, 'editAddressLabel'),
    removeAddressLabel: getTextFromResource(getText, 'removeAddressLabel'),
    addShippingAddress: getTextFromResource(getText, 'addShippingAddress')
});
